// Unifi Testnet network configuration.
// Values come from the environment (REACT_APP_*) so they can be overridden
// per environment without code changes. Defaults are the public testnet.

export const UNIFI_CHAIN_ID = Number(
  process.env.REACT_APP_UNIFI_CHAIN_ID ?? 2092151908,
);

export const UNIFI_RPC_URL =
  process.env.REACT_APP_UNIFI_RPC_URL ?? "https://testnet-unifi-rpc.puffer.fi/";

export const UNIFI_EXPLORER_URL =
  process.env.REACT_APP_UNIFI_EXPLORER_URL ??
  "https://testnet-unifi-explorer.puffer.fi";

export const UNIFI_EXPLORER_API_URL =
  process.env.REACT_APP_UNIFI_EXPLORER_API_URL ?? `${UNIFI_EXPLORER_URL}/api`;

export const txExplorerUrl = (txHash: string) =>
  `${UNIFI_EXPLORER_URL}/tx/${txHash}`;

// AP2 service endpoint for agent-signed transactions
export const AP2_SERVICE_URL =
  process.env.REACT_APP_AP2_SERVICE_URL ?? "http://localhost:8000/ap2-service";
